import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'y42-show-grid-button',
  templateUrl: './show-grid-button.component.html',
  styleUrls: ['./show-grid-button.component.scss'],
})
export class ShowGridButtonComponent {
  @Input() showGrid = false;
  @Output() readonly toggleShowGrid = new EventEmitter<boolean>();
}
